import React, { useMemo } from 'react';
import { FiX } from 'react-icons/fi';
import StarRating from '../Common/StarRating';
import './AiSuggestedSiteCriteriaModal.css';

const DEFAULT_AI_RATING_PARAMETERS = [
  'Disease Research Activity',
  'Investigator Expertise',
  'Clinical Trial History',
  'Infrastructure',
  'Patient Pool',
];

const PARAMETER_DESCRIPTIONS = {
  'Disease Research Activity':
    'How active the site is in research aligned with the study disease or indication.',
  'Investigator Expertise':
    'Principal investigator and team experience relevant to the therapeutic area.',
  'Clinical Trial History':
    'Track record conducting clinical trials and similar studies.',
  Infrastructure:
    'Facilities, staffing, and operational capacity to run the protocol.',
  'Patient Pool':
    'Access to and volume of patients who may meet enrollment criteria.',
};

function getRatingParameterNames(site) {
  const fromArray = [
    ...(Array.isArray(site?.ratingParameters) ? site.ratingParameters : []),
    ...(Array.isArray(site?.ratingParameterNames) ? site.ratingParameterNames : []),
    ...(Array.isArray(site?.scoreParameters) ? site.scoreParameters : []),
  ]
    .map((x) => String(x || '').trim())
    .filter(Boolean);

  if (fromArray.length > 0) {
    return [...new Set(fromArray)];
  }

  const fromExpertise = String(site?.therapeuticExpertise || '')
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);
  if (fromExpertise.length > 0) {
    return [...new Set(fromExpertise)];
  }

  return DEFAULT_AI_RATING_PARAMETERS;
}

const AiSuggestedSiteCriteriaModal = ({
  site,
  diseaseLabel,
  therapeuticAreaLabel,
  onClose,
}) => {
  const parameterNames = useMemo(() => getRatingParameterNames(site), [site]);
  const scoreNum = site?.score != null && site?.score !== '' ? Number(site.score) : null;
  const hasValidScore = scoreNum != null && !Number.isNaN(scoreNum);
  const starRating = hasValidScore ? scoreNum / 20 : null;

  return (
    <div className="modal-overlay ai-suggested-criteria-overlay" onClick={onClose}>
      <div className="ai-suggested-criteria-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ai-suggested-criteria-header">
          <h4>Rating criteria — {site?.siteName || 'Site'}</h4>
          <button type="button" className="ai-suggested-criteria-close" onClick={onClose} aria-label="Close">
            <FiX size={22} />
          </button>
        </div>

        <div className="ai-suggested-criteria-body">

          <h4 className="ai-suggested-criteria-section-title">Parameters used for this score :</h4>

          <ul className="ai-suggested-criteria-list">
            {parameterNames.map((name) => (
              <li key={name}>
                <span className="ai-suggested-criteria-param-name">{name}</span>
                {PARAMETER_DESCRIPTIONS[name] && (
                  <span className="ai-suggested-criteria-param-desc">{PARAMETER_DESCRIPTIONS[name]}</span>
                )}

              </li>
            ))}
          </ul>
        </div>

        <div className="ai-suggested-criteria-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiSuggestedSiteCriteriaModal;
